/**
 * Best-effort client-side cleanup for a wedged Frontegg login.
 *
 * A 431 on oauth/token means the accumulated fe_* cookie payload outgrew the
 * server's header limit — those cookies are re-sent on every retry, so the
 * login loops until the client state is cleared. localStorage fe_* keys and
 * every cookie reachable from JS on this origin are removed; HttpOnly cookies
 * can't be touched from here and are left for the /oauth/logout redirect to
 * clear server-side.
 */
export function clearFronteggClientState(): void {
  for (const key of Object.keys(window.localStorage)) {
    if (key.startsWith('fe_')) {
      window.localStorage.removeItem(key)
    }
  }

  const expiry = 'expires=Thu, 01 Jan 1970 00:00:00 GMT'
  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0]?.trim()
    if (!name) continue
    // Expire against both the bare path and the hostname — cookies set with
    // an explicit domain attribute only clear when it is repeated.
    document.cookie = `${name}=; ${expiry}; path=/`
    document.cookie = `${name}=; ${expiry}; path=/; domain=${window.location.hostname}`
  }
}
